import React from 'react';

export { PillWithRadioDropdown } from './PillWithRadioDropdown';
export { PillWithCheckboxDropdown } from './PillWithCheckboxDropdown';

export type PillDropdownOptions = { text: string; value: string }[];

const ESCAPE_KEY = 'Escape';

interface OutsideClickHookProps {
  onOutsideAction: () => void;
  elementRef: React.RefObject<HTMLDivElement>;
}

export const useHandleOutsideClick = ({ onOutsideAction, elementRef }: OutsideClickHookProps) => {
  const handleOutsideClick = React.useCallback(
    (e: MouseEvent) => {
      if (!e.target || !elementRef.current) {
        return;
      }
      if (elementRef.current?.contains(e.target as Node)) {
        return;
      } else {
        onOutsideAction();
      }
    },
    [elementRef, onOutsideAction]
  );

  const handleEscapeClose = React.useCallback(
    (e: KeyboardEvent) => {
      if (e.key === ESCAPE_KEY) {
        onOutsideAction();
      }
    },
    [onOutsideAction]
  );

  React.useEffect(() => {
    document.addEventListener('keydown', handleEscapeClose);
    return () => document.removeEventListener('keydown', handleEscapeClose);
  }, [handleEscapeClose]);

  React.useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [handleOutsideClick]);
};
